export interface ITcCertifiedRawMaterialInformation {
  additionalProp1?: {
  },
  tcCertifiedRawMaterialCode: string;
  tcCertifiedRawMaterialWeight: number;
  tcCertifiedRawMaterialCountryOrArea: any;
  tcCertifiedRawMaterialStateOrProvince: any;
}

export interface ITcStandardCertifiedWeightInformation {
  additionalProp1?: {
  },
  tcStandard: string;
  tcCertifiedWeight: number;
  tcCertifiedRawMaterialInformation: ITcCertifiedRawMaterialInformation[];
}

export interface ITcDetails {
  additionalProp1?: {
  },
  tcStandardCertifiedWeightInformation: ITcStandardCertifiedWeightInformation[];
}

export interface ITcCertifiedWeightInfo {
  additionalProp1?: {
  },
  tcId: string;
  tcDetails: ITcDetails;
}

interface RawMaterialInformation {
  tcCertifiedRawMaterialCode: string;
  tcCertifiedRawMaterialWeight: number;
  tcCertifiedRawMaterialCountryOrArea: string[];
  tcCertifiedRawMaterialStateOrProvince: string[];
}

interface StandardCertifiedWeightInformation {
  tcStandard: string;
  tcCertifiedWeight: number;
  tcCertifiedRawMaterialInformation: RawMaterialInformation[];
}

interface TCDetails {
  tcStandardCertifiedWeightInformation: StandardCertifiedWeightInformation[];
}

interface InputData {
  tcId: string;
  tcDetails: TCDetails;
}

export function transformToRowData(data: InputData){
  if (!data || !data.tcDetails || !Array.isArray(data.tcDetails.tcStandardCertifiedWeightInformation)) {
      throw new Error("Invalid input format");
  }

  return data.tcDetails.tcStandardCertifiedWeightInformation.flatMap(info => {
      const tcStandard = info.tcStandard || "";

      return info.tcCertifiedRawMaterialInformation.map(rawMaterial => ({
          tcStandard: tcStandard,
          rawMaterialWeight: rawMaterial.tcCertifiedRawMaterialWeight.toString(),
          rawMaterialCode: rawMaterial.tcCertifiedRawMaterialCode,
          country: rawMaterial.tcCertifiedRawMaterialCountryOrArea,
          state: rawMaterial.tcCertifiedRawMaterialStateOrProvince,
      }));
  });
}